import {
  GET_USERS,
  UPDATE_USER,
  CREATE_USER,
  DELETE_USER,
} from '../actions/users';
import _ from 'lodash';

const INITIAL_STATE = [];

export default function (state = INITIAL_STATE, action) {
  let index = -1;
  switch (action.type) {
    case GET_USERS:
      return [].concat(action.value.data);

    case UPDATE_USER:
      index = _.findIndex(state, { '_id':  action.value._id});
      state[index] = action.value;
      return [].concat(state);

    case CREATE_USER:
      return [action.value].concat(state);

    case DELETE_USER:
      index = _.findIndex(state, { '_id':  action.value._id});
      if (index !== -1) {
        state.splice(index, 1);
      }
      return [].concat(state);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js